import { render } from "./gw.vue?vue&type=template&id=4de1b4f8"
import script from "./gw.vue?vue&type=script&lang=js"
export * from "./gw.vue?vue&type=script&lang=js"

import "./gw.vue?vue&type=style&index=0&id=4de1b4f8&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__